.container {
  margin: 8px;
  display: flex;
  flex-direction: column;
}

.sliderGrid {
  display: flex;
  flex-direction: column;
}

.slider {
  min-width: 100px;
}
